/* ─────────────────────────────────────────────
   SCORING
   Place: mean of all answers (1.00–1.75 A · >1.75–2.50 B · >2.50–3.25 C · >3.25–4.00 D)
   Stuck dimension: lowest mean per dimension.
   Tie-break priority: grief > safety > identity > somatic > control > social
───────────────────────────────────────────── */
export const TIE_PRIORITY = [
  "grief",
  "safety",
  "identity",
  "somatic",
  "control",
  "social",
];

export function computeResult(answers) {
  const mean = answers.reduce((a, b) => a + b.v, 0) / answers.length;
  let place;
  if (mean <= 1.75) place = "A";
  else if (mean <= 2.5) place = "B";
  else if (mean <= 3.25) place = "C";
  else place = "D";
  const dimScores = {};
  answers.forEach((a) => {
    (dimScores[a.dim] = dimScores[a.dim] || []).push(a.v);
  });
  let stuck = null,
    lowest = Infinity;
  TIE_PRIORITY.forEach((d) => {
    if (dimScores[d]) {
      const m = dimScores[d].reduce((x, y) => x + y, 0) / dimScores[d].length;
      if (m < lowest) {
        lowest = m;
        stuck = d;
      }
    }
  });
  return { place, stuck, mean, dimScores };
}

/* ─────────────────────────────────────────────
   THE CARRIED-QUESTION MATRIX
   bespoke cells + row defaults. A: held back. D: shared outward question.
───────────────────────────────────────────── */
export const MATRIX = {
  B: {
    identity: {
      q: "What is the flatness trying to tell me — the one I keep explaining away?",
    },
    somatic: {
      q: "What might that quiet signal be saying — if I let it finish its sentence?",
    },
    safety: {
      q: "What's the feeling that shows up right before I decide to stay quiet?",
    },
    default: {
      q: "What is this feeling trying to tell me — the one I keep setting aside?",
    },
  },
  C: {
    identity: {
      q: "What's one thing I might be protecting by staying on this path?",
    },
    control: {
      q: "What's one thing I'm gripping that might move if I loosened my hold?",
    },
    grief: {
      q: "What's one thing I haven't let myself mourn — because mourning it would make the change real?",
    },
    default: {
      q: "What's one thing I might be protecting by staying where I am?",
    },
  },
  D: {
    default: {
      q: "Who around me is standing at a threshold I've already crossed?",
    },
  },
};

/* Quality callback: stuck dimension → homepage persona quality (only where honest) */
export const QUALITY = {
  identity: {
    name: "the Whisper",
    desc: "questions starting to surface that the usual answers don't quite satisfy",
  },
  safety: {
    name: "the Hunger",
    desc: "a thirst the next achievement keeps promising to satisfy — and doesn't quite",
  },
  social: {
    name: "the Loneliness of Success",
    desc: "a hunger for the kind of honest, unguarded conversation that's grown rare",
  },
  grief: {
    name: "the Sense",
    desc: "a growing feeling that waiting for the next milestone to feel like enough may not be the plan",
  },
};
